<template>
  <section class="team-prev">
    <b-container class="h-100 bg-img">
      <b-row class="h-100 align-content-center">
        <b-col sm="12">
          <div class="profile-container">
            <div v-for="item in teams" :key="item.id" class="profile-card">
              <img class="profile-photo" :src="item.photo" alt="Profile photo">
              <h5 class="profile-name">{{item.name}}</h5>
              <p class="profile-position">{{item.position}}</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
      teams: [
        {
          name: 'Viktor Storozhuk',
          position: 'Founder & CEO',
          photo: require('@/assets/img/team/victor-storozhuk.jpg')
        },
        {
          name: 'Yaryna Mandyuk',
          position: 'Head of BD',
          photo: require('@/assets/img/team/yaryna-mandyuk.jpg')
        },
        {
          name: 'Stepan Butko',
          position: 'Product & Brand Designer',
          photo: require('@/assets/img/team/stepan-butko.jpg')
        },
        {
          name: 'Oleksandr Zvozdin',
          position: 'AWS services,  system design, devOps',
          photo: require('@/assets/img/team/oleksandr-zvozdin.jpg')
        },
        {
          name: 'Sliusar Ihor',
          position: 'Software engineer',
          photo: require('@/assets/img/team/sliusar-ihor.jpg')
        },
        {
          name: 'Artem Perov',
          position: 'Mobile Developer',
          photo: require('@/assets/img/team/artem-perov.jpg')
        },
        {
          name: 'Volodymyr Storozhuk',
          position: 'Web Developer',
          photo: require('@/assets/img/team/volodymyr-storozhuk.jpg')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/app";
.team-prev{
  padding-top: 80px;
  padding-bottom: 80px;
  background: radial-gradient(66.25% 121.93% at 70.64% -15.07%, #8184F9 12.26%, #5C5EE8 91.15%);
  .bg-img{
    min-height: 500px;
    background-image:  url('../../assets/img/new-content/team-bg-image.svg');
    background-repeat: no-repeat;
    background-position: bottom -18px right;
  }
  .profile-container {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    @media screen and (min-width: 320px) {
      gap: 16px;
    }
    @media screen and (min-width: 425px) {
      gap: 24px;
    }
  }
  .profile-card {
    display: flex;
    flex-direction: column;
    max-width: 219px;
    min-height: 290px;
    width: 100%;
    background: #fff;
    padding: 16px;
    border-radius: 20px;
    @media screen and (min-width: 320px) {
      max-width: calc(50% - 8px);
    }
    @media screen and (min-width: 425px) {
      max-width: unset;
      width: calc(50% - 12px);
    }
    @media screen and (min-width: 768px) {
      width: calc(33% - 14px);
    }
    @media screen and (min-width: 1199px) {
      width: calc(24% - 7px);
    }
    @media screen and (min-width: 1440px) {
      width: 18%;
    }
    @media screen and (min-width: 1920px) {
      width: calc(19.9% - 18px);
    }
    .profile-photo{
      width: 100%;
      margin-bottom: 16px;
    }
    .profile-name{
      font-family: $main-font;
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
      text-align: left;
      margin: 0 0 8px 0;
    }
    .profile-position{
      font-family: $main-font;
      font-size: 14px;
      font-weight: 300;
      line-height: 16px;
      text-align: left;
      margin: 0;
    }
  }
}
</style>
